import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMasonry32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMasonry32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 8h5v7H5v-5a2 2 0 0 1 2-2m7 7V8h11a2 2 0 0 1 2 2v5zm-9 2v5a2 2 0 0 0 2 2h11v-7zm15 0v7h5a2 2 0 0 0 2-2v-5zM3 10a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMasonry32);
